import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHECKLIST_DUOTONE_ICONS } from "../utils/svgs_duotone";
import { AppIcon } from "./Generic/AppIcon";
import { AppListItem } from "./Generic/AppList";
import NextButton from "./NextButton/NextButton";

type Props = {
  onClick: () => void;
};

export default function PatientScheduleListItem(props: Props) {
  return (
    <AppListItem
      leading={<AppIcon icon={CHECKLIST_DUOTONE_ICONS} />}
      title={translate(STRINGS.PATIENT_SCHEDULE)}
      trailing={<NextButton />}
      onClick={props.onClick}
    />
  );
}
